<template>
  <el-form
    ref="ruleFormRef"
    :model="ruleForm"
    :rules="rules"
    label-width="110px"
    class="demo-ruleForm"
    size="large"
    status-icon
  >
    <el-form-item label="专业名称" prop="name">
      <el-input
        v-model="ruleForm.name"
        placeholder="请填写专业名称"
        class="middle_input"
      />
    </el-form-item>

    <el-form-item label="所属年份" prop="year">
      <el-select
        v-model="currentYear"
        class="m-2 middle_input"
        placeholder="请选择所属年份"
        @change="changeYear"
      >
        <el-option
          v-for="item in yearsSel"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="所属专业类别" prop="majorCategoryId">
      <el-select
        v-model="ruleForm.majorCategoryId"
        class="m-2 middle_input"
        placeholder="请选择专业类别"
      >
        <el-option
          v-for="item in categorySel"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </el-form-item>
  </el-form>
  <div slot="footer" class="from_btn">
    <el-button @click="resetForm" size="large">取消</el-button>
    <el-button type="primary" size="large" @click="submitForm(ruleFormRef)"
      >提交</el-button
    >
  </div>
</template>

<script>
import { addMajorPt, updateMajorPt } from "network/pbMajor.js";
import { toRefs, reactive, ref, unref, onMounted, toRaw } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
export default {
  name: "AddEditPbMajor",
  components: {},
  emits: {
    "close-dialog": null,
    "update-list": null,
  },
  props: {
    isEdit: Boolean,
    editObj: Object,
    yearsSel: Array,
    categorySel: Array,
  },
  setup(props, { emit }) {
    const ruleFormRef = ref();
    const data = reactive({
      ruleForm: {
        name: "",
        year: null,
        majorCategoryId: null,
      },
      rules: {
        name: [
          { required: true, message: "请填写专业名称" },
          { min: 2, max: 20, message: "专业名称为2-20字" },
        ],

        year: [
          {
            required: true,
            message: "请选择所属年份",
            trigger: "change",
          },
        ],
        majorCategoryId: [
          {
            required: true,
            message: "请选择所属专业类别",
            trigger: "change",
          },
        ],
      },
      currentYear: "", //当前年
    });
    onMounted(() => {
      // 默认当前年份
      data.ruleForm.year = toRaw(props.yearsSel)[0].key;
      data.currentYear = toRaw(props.yearsSel)[0].value; 
       //编辑-获取详情
    if (props.editObj && props.isEdit) {
      data.ruleForm = JSON.parse(JSON.stringify(props.editObj));
    }
    });
    
    //选择年份
    const changeYear = (val) => {
      data.ruleForm.year = val;
    }; // 提交
    const submitForm = async () => {
      const form = unref(ruleFormRef);
      if (!form) return;
      try {
        const valid = await form.validate();
        if (!valid) {
          return false;
        } else {
          console.log(data.ruleForm, "提交数据");
          updataAdd(data.ruleForm);
        }
      } catch (error) {
        ElMessage.error("有必填内容未填写！");
        console.log(error);
      }
    };
    async function updataAdd(data) {
      data.loading = true;
      let result = "";
      if (props.isEdit) {
        result = await updateMajorPt(data);
      } else {
        result = await addMajorPt(data);
      }
      if (result && result.code == 1) {
        data.loading = false;
        ElMessageBox.alert(result.message, props.isEdit ? "编辑" : "添加", {
          confirmButtonText: "确定",
                  });
        emit("close-dialog");
        emit("update-list");
      } else {
        data.loading = false;
        ElMessageBox.alert(result.message, props.isEdit ? "编辑" : "添加", {
          confirmButtonText: "确定",
                  });
      }
    }

    // 取消操作  关闭弹窗
    const resetForm = () => {
      emit("close-dialog");
      ruleFormRef.value.resetFields();
    };
    return {
      ...toRefs(data),
      changeYear,
      submitForm,
      ruleFormRef,
      resetForm,
    };
  },
};
</script>
<style scoped>
:deep(.el-input__inner) {
  outline: none;
  line-height: 1px;
}

.demo-ruleForm {
  width: 100%;
  height: 250px;
}
</style>

